import { __decorate } from "tslib";
// Core
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import { ROUTE } from '@/helpers/constants/Store';
// Extends
import PaginatorMixin from '@/helpers/mixins/PaginatorMixin';
// Children
import BaseText from '@/components/BaseText.vue';
import SwitchTransition from '@/components/page_transition/Switch.vue';
// Models / Helpers
// Queries / Mutations
import PromoCodeQuery from '@/plugins/graphql/queries/v3/fetch-usable-promo-codes.gql';
/**
 * <class>
 * @author Jan Canicon <jan@gorated.ph>
 *                     <jancanicon.work@gmail.com>
 * @since Version {x.xx.x}
 *
 * Docs: <url>
 */
let ExplainerVoucher = class ExplainerVoucher extends Mixins(PaginatorMixin) {
    constructor() {
        super(...arguments);
        this.promoCodes = [];
        this.expanded = [false, true];
        this.selectedPromoCode = null;
    }
    get voucherID() {
        return this.selectedPromoCode?.baseGlobalId;
    }
    get voucherCode() {
        return this.selectedPromoCode?.code;
    }
    get voucherValue() {
        if (this.selectedPromoCode.valueType === 'percentage') {
            return `${this.selectedPromoCode.value}%`;
        }
        return `₱${this.selectedPromoCode.value}`;
    }
    selectVoucher(baseGlobalId) {
        [this.selectedPromoCode] = this.promoCodes.filter((promoCode) => promoCode.baseGlobalId === baseGlobalId);
    }
    redirectToVoucherPage() {
        this.setRouteRedirection({
            from: 'ecommerce-promos-create',
            to: 'ecommerce-promos',
            override: this.$route.name,
        });
        this.$router.push({ name: 'ecommerce-promos-create' });
    }
    created() {
        if (this.formData) {
            this.selectedPromoCode = this.formData;
        }
    }
};
__decorate([
    Prop({ type: Object, default: null })
], ExplainerVoucher.prototype, "formData", void 0);
__decorate([
    Mutation('setRouteRedirection', { namespace: ROUTE })
], ExplainerVoucher.prototype, "setRouteRedirection", void 0);
ExplainerVoucher = __decorate([
    Component({
        components: {
            BaseText,
            SwitchTransition,
        },
        apollo: {
            fetchUsablePromoCodes: {
                query: PromoCodeQuery,
                variables() {
                    return {
                        appUuid: this.$store.state.appUUID,
                    };
                },
                update({ fetchUsablePromoCodes }) {
                    this.promoCodes = [...fetchUsablePromoCodes.edges.map((edge) => edge.node)];
                },
                skip() {
                    return !this.$store.state.appUUID;
                },
                fetchPolicy: 'network-only',
            },
        },
    })
], ExplainerVoucher);
export default ExplainerVoucher;
